export default {
    apiKey: "AIzaSyCc2pIu41PSXinKKpKhGD6SNkynwvmNnkg",
    authDomain: "servi-forms.firebaseapp.com",
    databaseURL: "https://servi-forms.firebaseio.com",
    projectId: "servi-forms",
    storageBucket: "servi-forms.appspot.com",
    messagingSenderId: "1015371950907",
    appId: "1:1015371950907:web:156a23d6b34898f82c251e"
};
